import { FC } from "react";
import Container from "react-bootstrap/Container";
import { FaPlus } from "react-icons/fa";
import { NavigationScreen } from "app/component/screen/NavigationScreen";
import { createTestTypePrerequisiteRoute, testTypePrerequisitesRoute } from "app/route/Routes";
import { Toolbar, ToolbarButtons, ToolbarTitle } from "app/component/util/Toolbar";
import { createTestTypePrerequisiteRole } from "app/api/graph/roles";
import { TestTypePrerequisitesTable } from "app/component/test-type-prerequisite/TestTypePrerequisitesTable";
import { useAuth } from "app/api/AuthContext";
import { RouteBreadcrumbs } from "app/route/RouteBreadcrumbs";
import { ButtonLink } from "app/component/button/ButtonLink";

export const TestTypePrerequisitesListScreen: FC = () => {
    const { roles } = useAuth();
    return (
        <NavigationScreen>
            <Container>
                <RouteBreadcrumbs route={testTypePrerequisitesRoute} />
                <Toolbar>
                    <ToolbarTitle>
                        <h1>Test type prerequisites</h1>
                    </ToolbarTitle>
                    <ToolbarButtons>
                        {roles?.includes(createTestTypePrerequisiteRole) ? (
                            <ButtonLink to={createTestTypePrerequisiteRoute.build({})} variant="success">
                                <FaPlus /> New prerequisite
                            </ButtonLink>
                        ) : null}
                    </ToolbarButtons>
                </Toolbar>
                <TestTypePrerequisitesTable />
            </Container>
        </NavigationScreen>
    );
};
